import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
/**
 * Check if we're running in a production environment
 * Uses hostname-based detection for UI components
 */
export function isProductionEnvironment() {
    if (typeof window === 'undefined') {
        return false; // Server-side rendering
    }
    const hostname = window.location.hostname;
    return hostname === 'playbook.airclou.com' || hostname.includes('airclou.com');
}
/**
 * Check if user switching UI should be shown
 * Only show in development environments
 */
export function shouldShowUserSwitcher() {
    return !isProductionEnvironment();
}
/**
 * True when an element's focus came from the keyboard (`:focus-visible`).
 * Use it to gate hover-style UI (tooltips, hints) shown on focus: a mouse
 * click focuses a button, and the browser re-focuses that button when the
 * window is re-activated (Cmd+Tab back). Showing a tooltip on either leaves
 * it stuck open with the pointer elsewhere, since no mouseleave follows.
 */
export function isKeyboardFocus(el) {
    try {
        return el.matches(':focus-visible');
    }
    catch {
        // Engines without :focus-visible: fail safe. A missing tooltip on Tab is a
        // smaller loss than one stuck open after a click.
        return false;
    }
}
//# sourceMappingURL=utils.js.map